import { Text, CopyButton, Tooltip, ActionIcon, Group } from '@mantine/core'
import { IconCopy, IconCheck } from '@tabler/icons-react'

interface ProtocolNumberBadgeProps {
  value: string | null | undefined
  withCopy?: boolean
}

export function ProtocolNumberBadge({ value, withCopy = false }: ProtocolNumberBadgeProps) {
  if (!value) return <Text size="xs" c="dimmed">—</Text>

  return (
    <Group gap={4} wrap="nowrap">
      <Text
        size="xs"
        ff="monospace"
        fw={600}
        c="blue.7"
        // whiteSpace nowrap: desde que o protocolo passou a incluir organização e
        // ambiente (24-27 chars, spec 2026-07-28), ele quebrava em duas linhas em
        // colunas estreitas (card da Minha Fila) e a quebra comprimia o badge de
        // prioridade ao lado até truncar ("CRITICAL" -> "CRITIC..."). O protocolo
        // é um identificador para copiar: não pode quebrar nem encurtar.
        style={{ letterSpacing: '0.04em', whiteSpace: 'nowrap' }}
      >
        {value}
      </Text>
      {withCopy && (
        <CopyButton value={value} timeout={1500}>
          {({ copied, copy }) => (
            <Tooltip label={copied ? 'Copiado!' : 'Copiar'} withArrow>
              <ActionIcon
                size="xs"
                variant="subtle"
                color={copied ? 'teal' : 'gray'}
                onClick={copy}
              >
                {copied ? <IconCheck size={10} /> : <IconCopy size={10} />}
              </ActionIcon>
            </Tooltip>
          )}
        </CopyButton>
      )}
    </Group>
  )
}
